import React from 'react';
import Heading from '../ui/Heading';
import Button from '../ui/Button';
import Section from '../ui/Section';
import img from '../../assets/exterior/vasudharinihomes_exterior_3.png'

const AboutPreview = () => {
  return (
    <Section className='py-18 sm:py-24'>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center ">
        <div className='order-2 md:order-1'>
          <img 
            src={img}
            alt="Vasudharini Team" 
            className=" w-full h-52 sm:h-80 object-cover"
          />
        </div>
        
        <div className='order-1 md:order-2 text-center md:text-left'>
          <Heading level={2} className=''>Welcome to Vasudharini</Heading>
          <p className=" mb-8 sm:my-10 sm:text-lg">
            Vasudharini Homes LLP is a dynamic and
            forward-thinking construction company
            that is committed to addressing the
            housing needs of the middle-income group.
            Our mission is to provide affordable and
            high-quality residential properties by
            incorporating innovative construction
            materials and techniques to reduce
            construction costs without compromising
            on quality or safety.
          </p>
          {/* <p className="text-gray-700 mb-8 sm:my-10">
            Vasudharini means bearer of earth. Housing being an earthly need encouraged us to come up with this name.
            We are operating in different real estate sectors for several years, starting as an agency, then as a consultant,
            and now developing and promoting our own properties.
          </p> */}
          
          {/* <p className="text-gray-700 mb-5">
            Our mission is to develop and deliver affordable housing projects with a long-term vision to be an industry 
            leader. We stand for developing and promoting affordable homes, with our buyers' dreams and budgets 
            guiding our development process.
          </p> */}
          
          {/* <div className="flex items-center space-x-4 mb-8 ">
            <div className="h-1 w-8 sm:w-12 bg-yellow-400"></div>
            <p className="text-lg sm:text-xl font-medium">Committed in delivering our promises</p>
          </div> */}
          
          <Button to="/about" variant='outlineSecondary'>Learn More About Us</Button>
        </div>
      </div>
    </Section>
  );
};

export default AboutPreview;